import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"width":"235px"} }
const _hoisted_2 = { style: {"font-size":"16px","font-weight":"400","line-height":"24px","letter-spacing":"0.08px","color":"#16161d"} }
const _hoisted_3 = {
  key: 0,
  style: {"font-size":"14px","font-weight":"400","line-height":"18px","letter-spacing":"0.07px","color":"#68688d"}
}

import type { RuleBuilderOperatorOption } from './types'

interface Props {
  modelValue: string
  options: RuleBuilderOperatorOption[]
  disabled?: boolean
  label?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RuleBuilderOperator',
  props: {
    modelValue: {},
    options: {},
    disabled: { type: Boolean, default: false },
    label: { default: 'Operador' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_select, {
      "model-value": _ctx.modelValue,
      items: _ctx.options,
      "item-value": "value",
      "item-title": "label",
      label: _ctx.label,
      variant: "outlined",
      density: "comfortable",
      disabled: _ctx.disabled,
      "data-testid": "rule-builder-operator-selector",
      "hide-details": "auto",
      class: "bg-white",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => emit('update:modelValue', val))
    }, {
      item: _withCtx(({ props: itemProps, item }) => [
        _createVNode(_component_v_list_item, _mergeProps(itemProps, {
          title: undefined,
          subtitle: undefined
        }), {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(item.raw.label), 1),
              (item.raw.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.raw.description), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    }, 8, ["model-value", "items", "label", "disabled"])
  ]))
}
}

})